import { render, staticRenderFns } from "./EpBenefitCardList.vue?vue&type=template&id=11024668&"
import script from "./EpBenefitCardList.vue?vue&type=script&lang=js&"
export * from "./EpBenefitCardList.vue?vue&type=script&lang=js&"
import style0 from "./EpBenefitCardList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports